export default "__VITE_ASSET__CoTgNdim__"